import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { ValidateFieldService } from '@shared/services/validateField.service';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.sass'],
})
export class InputSelectComponent {
  @Input() label: string;
  @Input() formGroup: FormGroup;
  @Input() formControlName: string;
  @Input() options: Array<string>;
  @Input() value: string;
  @Input() key: string;

  constructor(public validate: ValidateFieldService) {}

  get formControl(): AbstractControl {
    return this.formGroup?.controls[this.formControlName];
  }
}
